import { useAsObservableSource, useLocalStore } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';
import { Group } from 'STORE/Groups/Group';

interface IAllPinsPresenter {
  group: Group | null;
  onBack(): void;
}

export function useAllPinsPresenter(groupId?: string): IAllPinsPresenter {
  const navigate = useNavigate();
  const source = useAsObservableSource({ groupId, navigate });

  const presenter = useLocalStore<IAllPinsPresenter>(() => ({
    get group(): Group | null {
      return source.groupId ? Entities.GroupsStore.getGroupById(source.groupId) : null;
    },

    onBack(): void {
      if (presenter.group?.routePath) {
        source.navigate(presenter.group.routePath);
      }
    },
  }));

  useEffect(() => {
    if (presenter.group) {
      Tasks.messaging.loadPinMessages(presenter.group);
    }
  }, [presenter.group]);

  return presenter;
}
